// src/ops/types/CronJobs.ts
var CronService = /* @__PURE__ */ ((CronService2) => {
  CronService2["Main"] = "main";
  CronService2["Booking"] = "booking";
  CronService2["Payment"] = "payment";
  CronService2["IcalSync"] = "ical-sync";
  CronService2["Pricing"] = "pricing";
  CronService2["Chat"] = "chat";
  return CronService2;
})(CronService || {});
var CronJobCriticality = /* @__PURE__ */ ((CronJobCriticality2) => {
  CronJobCriticality2["P0"] = "P0";
  CronJobCriticality2["P1"] = "P1";
  CronJobCriticality2["P2"] = "P2";
  CronJobCriticality2["P3"] = "P3";
  return CronJobCriticality2;
})(CronJobCriticality || {});

export {
  CronService,
  CronJobCriticality
};
